import React from 'react';
import {Link} from 'react-router-dom';
import CommonButtonComponent from '../../../utility/components/CommonButton';
import './Header.css';

export const Header = () => {
    return (
        <div className="home-header">
            <div id='header__background-img'></div>
            
            <div className='header__content'>
                <h1 className='header__title'><span>Innovative Designs</span> for <span>Modern Living</span></h1>
                <Link to="/quiz">
                    <CommonButtonComponent color='white' presetStyle='light'>
                        Style Quiz
                    </CommonButtonComponent>
                </Link>
            </div>
        </div>
    );
};